import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { integrationApi, type GatewayDashboard, type IntegrationDashboard } from '../../api/integration';

export function APIAnalyticsPage() {
  const [dash, setDash] = useState<IntegrationDashboard | null>(null);
  const [gateway, setGateway] = useState<GatewayDashboard | null>(null);

  useEffect(() => {
    void integrationApi.dashboard((getWorkspaceId() ?? '')).then(setDash);
    void integrationApi.gatewayDashboard((getWorkspaceId() ?? '')).then(setGateway);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">API Analytics</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Usage analytics, quota management and integration KPIs.</p>
      <Link to="/integrations/gateway" className="mt-2 inline-block text-sm text-teal-700 hover:underline dark:text-teal-400">← API Gateway</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[
          { label: 'Events (24h)', value: dash?.events_published_24h ?? 0 },
          { label: 'Avg Latency (ms)', value: dash?.avg_latency_ms?.toFixed(0) ?? '0' },
          { label: 'Active Connectors', value: dash?.active_connectors ?? 0 },
          { label: 'API Keys', value: gateway?.api_keys ?? 0 },
        ].map((s) => (
          <div key={s.label} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{s.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
